/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React from 'react';

const Loader = () => {

    return (
        <div className="loader">
            <div className="inner one"/>
            <div className="inner two"/>
            <div className="inner three"/>
        </div>
    );
};

export default Loader;
